import { Component, OnInit, ViewChild, Input, TemplateRef, Output, Renderer2 } from '@angular/core';
import {
  CrawfordGridComponent, GridColumn, CrawfordSnackbarService, DateFormat,
  CrawfordApiGridAdaptor, ApiGridParameters, ITabComponent, CrawfordDialogComponent, DialogButton,
  CrawfordDownloadService, CrawfordSpinnerService
} from 'crawford-shell';

import { CommunicationService } from '../communication.service';
import { ActivatedRoute } from '@angular/router';
import { eventListData } from '../data/event-list.source';
import { DataManager } from '@syncfusion/ej2-data';
import { PageSettingsModel } from '@syncfusion/ej2-grids';
import { Event } from '../model/event.model';
import { EventDetail } from '../model/event-detail.model';
import { EmailDetail } from '../model/email-detail.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { global } from '../../app.settings';

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss']
})
export class EventListComponent implements OnInit, ITabComponent {

  @Input() public crawfordRef: string;
  @Output() public emailDetail: EmailDetail;
  @Output() public eventDetails: EventDetail;

  @ViewChild('ccogrid') public ccoGrid: CrawfordGridComponent;
  @ViewChild('templateIcon') templateIconRef: TemplateRef<any>;
  // @ViewChild('templateButton') templateButtonRef: TemplateRef<any>;

  /* Dialog box Initialization - Start */
  @ViewChild('emailDialog') public emailDialog: CrawfordDialogComponent;
  @ViewChild('eventDetailsDialog') public eventDetailsDialog: CrawfordDialogComponent;

  // to add buttons and its event on a custom dialog
  // customDialogButtons = [new DialogButton(this.nextClick.bind(this), { content: 'Ok', isPrimary: true }),
  // new DialogButton(this.cancelClick.bind(this), { content: 'Clear', isPrimary: false })];

  /* Dialog box Initalization - End */

  public dataLoaded: boolean;
  public adaptor: CrawfordApiGridAdaptor;
  public dataSource: DataManager;
  public gridData: Event[];
  public emailDetailsGroup: FormGroup;
  public formBuilder: FormBuilder;

  public pagerTotalRecordsCount = 10;
  public currentPage = 1;
  private goToPageNum = 1;
  private currentPageViewIndex = 0;

  public df: DateFormat = {
    type: 'date',
    format: global.dateTimeFormat
  };

  public displayColumns: GridColumn[] = [];

  public sortingSettings: any = {
    columns: [{ field: 'date', direction: 'descending' }]
  };

  public pageSettings: PageSettingsModel = {
    pageSize: 10
  };

  public toolbarSettings: string[] = ['Search'];

  constructor(private communicationService: CommunicationService,
    private snackbarService: CrawfordSnackbarService,
    private downloadService: CrawfordDownloadService,
    private spinnerService: CrawfordSpinnerService,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      if (params.id) {
        this.crawfordRef = params.id;
        this.dataLoaded = false;
      }
    });

    this.displayColumns = [
      new GridColumn('id', 'EventId', { visible: false }),
      new GridColumn('name', 'Event'),
      new GridColumn('documentName', 'Document'),
      new GridColumn('documentType', 'Document Type', { template: this.templateIconRef }),
      new GridColumn('party', 'Party'),
      new GridColumn('date', 'Date', { type: 'date', format: this.df }),
      new GridColumn('category', 'Category'),
      new GridColumn('additionalInfo', 'Additional Info', { visible: false, showInColumnChooser: false })
    ];
  }

  loadData(): void {
    if (!this.dataLoaded) {
      this.spinnerService.show('claimEventListSpinner');
      this.adaptor = this.initalizeAdaptor();
      this.createGridData();
      this.dataLoaded = true;
    }
  }

  private initalizeAdaptor(): CrawfordApiGridAdaptor {
    const parameters = new ApiGridParameters();
    parameters.top = this.pageSettings.pageSize;
    parameters.orderBy.columnName = this.sortingSettings.columns[0].field;
    parameters.orderBy.direction = this.sortingSettings.direction;

    return new CrawfordApiGridAdaptor(parameters);
  }

  createGridData() {
    this.communicationService.getEvents(this.crawfordRef).subscribe(events => {
      if (events) {
        events.forEach((event) => {
          event.iconClass = this.updateDocumentTypeToIcon(event.documentType);
          event.additionalInfo = this.getAdditionalInfo(event.documentType, event.date);
        });

        this.gridData = events;
      }
    });
  }

  public getAdditionalInfo(documentType: string, documentDate: Date): string {
    let retVal = '';
    const types = this.communicationService.documentType;

    if (documentType) {

      const type = types[documentType.toLowerCase()] ? types[documentType.toLowerCase()] : types['default'];

      if (type && type.synonyms.length) {
        retVal += type.synonyms.reduce((accumulator, currentVal) => accumulator += ', ' + currentVal);
      }
    }

    if (documentDate) {
      const date = new Date(documentDate);
      retVal += ' ' + date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    }

    return retVal;
  }

  public updateDocumentTypeToIcon(documentType: string): string {
    if (!documentType) {
      return null;
    }

    const types = this.communicationService.documentType;

    return types[documentType.toLowerCase()] ? types[documentType.toLowerCase()].icon : types['default'].icon;
  }

  public openDocument(event: EventDetail) {
    this.communicationService.getOpenDocument(this.crawfordRef, event.id).subscribe(response => {
      if (response) {
        this.downloadService.downloadFileFromResponse(response, event.documentName);
      } else {
        this.snackbarService.displayErrorMessage('Unable to download document ' + event.documentName);
      }
    });
  }

  onRowDataBound($event): void {
    const data = $event.data;
    const row = $event.row;

    if (data.documentName) {
      row.classList.add('selectable-row');
    }
  }

  onDataBound($event: any): void {
    this.spinnerService.hide('claimEventListSpinner');
  }

  onActionFailure($event): void {
    this.snackbarService.displayErrorMessage($event.error);
    this.spinnerService.hide('claimEventListSpinner');
  }



  /* start paging on dialog*/

  onNextClick(page) {
    const gridCurrentPage = this.getGridCurrentPage(page);
    if (this.goToPageNum < gridCurrentPage) {
      this.goToPageNum = gridCurrentPage;
      this.ccoGrid['grid'].goToPage(this.goToPageNum);
      setTimeout(() => {
        this.currentPageViewIndex = 0;
        this.updateDialogEventDetails(this.currentPageViewIndex);
      }, 1000);
    } else {
      this.currentPageViewIndex++;
      this.updateDialogEventDetails(this.currentPageViewIndex);
    }
  }

  onPreviousClick(page) {
    const gridCurrentPage = this.getGridCurrentPage(page);
    if (this.goToPageNum > gridCurrentPage) {
      this.goToPageNum = gridCurrentPage;
      this.ccoGrid['grid'].goToPage(this.goToPageNum);
      setTimeout(() => {
        this.currentPageViewIndex = this.pageSettings.pageSize - 1;
        this.updateDialogEventDetails(this.currentPageViewIndex);
      }, 1000);
    } else {
      this.currentPageViewIndex--;
      this.updateDialogEventDetails(this.currentPageViewIndex);
    }
  }

  onFirstClick(event) {
    this.goToPageNum = 1;
    this.ccoGrid['grid'].goToPage(this.goToPageNum);
    setTimeout(() => {
      this.currentPageViewIndex = 0;
      this.updateDialogEventDetails(this.currentPageViewIndex);
    }, 1000);
  }

  onLastClick(page) {
    this.goToPageNum = this.getGridCurrentPage(page);
    this.ccoGrid['grid'].goToPage(this.goToPageNum);
    setTimeout(() => {
      this.currentPageViewIndex = this.ccoGrid['grid'].currentViewData.length - 1;
      this.updateDialogEventDetails(this.currentPageViewIndex);
    }, 1000);
  }

  private getGridCurrentPage(page): number {
    const pageNumber = Math.floor(page / this.pageSettings.pageSize);
    const currentPage = page % this.pageSettings.pageSize === 0 ? pageNumber : pageNumber + 1;
    return currentPage;
  }

  private updateDialogEventDetails(currentPageView) {
    const event = this.ccoGrid['grid'].currentViewData[currentPageView];
    if (event['category'] === 'Email') {
      this.communicationService.getEmailDetails(this.crawfordRef, event['id']).subscribe(
        email => {
          if (email) {
            this.emailDetail = email;
            this.eventDetailsDialog.hideDialog();
            this.emailDialog.showDialog();
            this.setDialogPosition(this.emailDialog);
            this.setBodyNoScrolling();
          }
        });
    } else {
      this.communicationService.getEventDetails(this.crawfordRef, event['id']).subscribe(
        eventDetails => {
          if (eventDetails) {
            this.eventDetails = eventDetails;
            this.emailDialog.hideDialog();
            this.eventDetailsDialog.showDialog();
            this.setDialogPosition(this.eventDetailsDialog);
            this.setBodyNoScrolling();
          }
        });
    }
  }
  private attachedPagerToPopup() {
    const containers: NodeList = document.querySelectorAll('.e-footer-content');
    if (containers[0]['firstElementChild'].id === 'pagerPopupEmail'
      || containers[0]['firstElementChild'].id === 'pagerPopupEvent') {
      return;
    }
    const pagerEventPopup: HTMLElement = document.getElementById('pagerPopupEvent');
    const pagerEmailPopup: HTMLElement = document.getElementById('pagerPopupEmail');
    pagerEventPopup.classList.remove('hide-pager');
    pagerEmailPopup.classList.remove('hide-pager');
    pagerEventPopup.classList.add('pager-event-popup');
    pagerEmailPopup.classList.add('pager-event-popup');
    containers[0].insertBefore(pagerEmailPopup, containers[0].childNodes[0]);
    containers[1].insertBefore(pagerEventPopup, containers[1].childNodes[0]);
  }
  /* end  paging on dialog*/

  showEventDetails($event) {
    let event = new EventDetail();
    event = $event.data;

    if (event.category === 'Email') {
      this.communicationService.getEmailDetails(this.crawfordRef, event.id).subscribe(
        email => {
          if (email) {
            email.iconClass = this.updateDocumentTypeToIcon(email.attachmentType);
            this.emailDetail = email;
            this.emailDialog.showDialog();
            this.setDialogPosition(this.emailDialog);
            this.setBodyNoScrolling();
          }
        });
    } else {
      this.communicationService.getEventDetails(this.crawfordRef, event.id).subscribe(
        eventDetails => {
          if (eventDetails) {
            eventDetails.iconClass = this.updateDocumentTypeToIcon(event.documentType);
            this.eventDetails = eventDetails;
            this.eventDetailsDialog.showDialog();
            this.setDialogPosition(this.eventDetailsDialog);
            this.setBodyNoScrolling();
          }
        });
    }
    this.pagerTotalRecordsCount = this.ccoGrid['grid']['gridPager']['ej2_instances'][0].totalRecordsCount;
    this.goToPageNum = this.ccoGrid['grid'].pagerModule['pagerObj'].currentPage;
    this.currentPage = this.pageSettings.pageSize * (this.goToPageNum - 1) + $event.rowIndex + 1;
    this.currentPageViewIndex = $event.rowIndex;
    this.attachedPagerToPopup();
    this.ccoGrid.clearSelection();
  }
  /* Removes the dialog postion from abolute and makes it default */
  setDialogPosition(dialog) {
    dialog.ejDialog.element.style.position = ''
  }

  setBodyNoScrolling() {
    this.renderer.addClass(document.body, 'no-scroll');
  }

  removeBodyNoScrolling() {
    this.renderer.removeClass(document.body, 'no-scroll');
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/communication/event-list/event-list.component.ts